import { FallingLines, RotatingSquare, Grid } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { PARAMS } from "../util/GlobalConstants";

export const spinnerTypes = {
  FallingLines: "FallingLines",
  RotatingSquare: "RotatingSquare",
  Grid: "Grid",
};
export const sizes = {
  xs: "16",
  sm: "18",
  md: "36",
  lg: "64",
};

const Spinner = ({
  spinnerType = spinnerTypes.FallingLines,
  size = sizes.lg,
  color = "#3366ff",
  center = false,
  backdrop = true,
  message = "",
  className: newClassName = "",
}) => {
  const theme = useSelector((state) => state.theme.currentTheme);

  return (
    <div
      className={
        "flex-container-column small-content rs-loader-wrapper" +
        (newClassName !== "" ? " " + newClassName : "") +
        (center === true ? " rs-loader-center" : "") +
        (backdrop === true ? " rs-loader-backdrop-wrapper" : "") +
        (theme === PARAMS.theme.dark ? " rs-loader-inverse" : "")
      }
    >
      {backdrop === true && (
        <div className="rs-loader-backdrop" style={{ zIndex: 998 }}></div>
      )}
      <div className="rs-loader" style={{ zIndex: 999 }}>
        {spinnerType === spinnerTypes.FallingLines && (
          <FallingLines
            color={color}
            width={size}
            visible={true}
            ariaLabel="falling-lines-loading"
          />
        )}
        {spinnerType === spinnerTypes.RotatingSquare && (
          <RotatingSquare
            visible={true}
            height={size}
            width={size}
            color={color}
            ariaLabel="rotating-square-loading"
          />
        )}
        {spinnerType === spinnerTypes.Grid && (
          <Grid
            visible={true}
            height={size}
            width={size}
            color={color}
            ariaLabel="grid-loading"
            radius="10"
          />
        )}
        {message !== "" && (
          <span id="loader-label-:rk:" className="rs-loader-content">
            {message}
          </span>
        )}
      </div>
    </div>
  );
};

export default Spinner;
